<template>
    <div class="SceneMatter"></div>
</template>

<script>

import Matter from 'matter-js'

export default {

    name: 'SceneMatter',

    beforeDestroy() {
        
    },

    created() {

        this.$coef = this.$parent.$coef
        this.$debug = this.$parent.$debug

        this.$id = 0
        this.$rayon = 80
        this.$coef_video = 2

        this.$Engine = Matter.Engine
        this.$World = Matter.World
        this.$Bodies = Matter.Bodies
        this.$Body = Matter.Body
        this.$Events = Matter.Events
        this.$engine = this.$Engine.create()
        this.$world = this.$engine.world
        this.$Vertices = Matter.Vertices
        this.$Composite = Matter.Composite

        this.$parent.$Engine = this.$Engine 
        this.$parent.$World = this.$World 
        this.$parent.$Bodies = this.$Bodies 
        this.$parent.$Body = this.$Body
        this.$parent.$Events = this.$Events
        this.$parent.$engine = this.$engine 
        this.$parent.$world = this.$world 
        this.$parent.$Vertices = this.$Vertices
        this.$parent.$Composite = this.$Composite 

        this.$bulles = []
        this.$width = this.$parent.$width
        this.$height = this.$parent.$height

        this.$loops = { 0: 0, 1: 0 }
        this.$old = [1, 1]
        this.$parent.$old = this.$old
        this.$locked = false 
    },

    mounted() {

        this.$bodies = []
        this.$parent.$bodies = this.$bodies
        this.$World.add(this.$engine.world, this.$bodies)
        this.$Engine.run(this.$engine)
        if(this.$debug) this.initMatter()
        this.addFace() 
    },

    methods: {

        addFace() {

            const st = { x: 540, y: 960 }

            this.$face_0 = this.$Bodies.polygon(st.x, st.y, 6, this.$rayon, { isStatic: true, chamfer: { radius: 25 }, collisionFilter: { category: 0x0001 } })
            this.$face_1 = this.$Bodies.polygon(st.x, st.y, 6, this.$rayon, { isStatic: true, chamfer: { radius: 25 }, collisionFilter: { category: 0x0001 } })
            this.$World.add(this.$world, [ this.$face_0, this.$face_1 ])
            this.$parent.$face_0 = this.$face_0
        },

        resetFacePositions(arr) {

            _.each(arr, (val)=>{
                this.$loops[val] = 0
                this.$Body.setPosition(this['$face_'+ val], { x: -1000, y: -1000 })
                this.resetScale(val)
                this.$old[val] = 1
            })
        },

        resetMatter() {

            this.$locked = true
            if(this.$tween) this.$tween.kill()
            this.resetScale(0)
            this.resetScale(1)

            this.$tween = TweenMax.delayedCall(1, ()=>{ 
                this.$old[0] = 1
                this.$old[1] = 1
                this.$locked = false 
            })
        },

        updateMatter(poses) {

            if(poses.length === 0) this.resetFacePositions([0,1])
            else if(poses.length === 1) this.resetFacePositions([1])

            _.each(poses, (pose, ref)=>{
                this.updateMatterFace(pose,ref)
            })
        },

        updateMatterFace(pose, ref) {    

            this.$loops[ref] += 1
            if(this.$loops[ref] < 20) return

            const pos = pose.keypoints[0].position
            const dist = Math.round(this.getDistance( pose.keypoints[1].position.x, pose.keypoints[1].position.y, pose.keypoints[2].position.x, pose.keypoints[2].position.y))*this.$coef_video  
            const ratio = Math.round(((dist/this.$rayon)*100)*1.5)/100

            // if(this.$parent.mode === 'champagne') pos.y += 20
            if(this.$parent.mode === 'petals') pos.y -= 20*this.$coef_video
            this.$Body.setPosition(this['$face_'+ ref], { x: pos.x*this.$coef_video, y: pos.y*this.$coef_video })

            if(!this.$locked) {
                this.resetScale(ref)
                this.$Body.scale(this['$face_'+ ref], ratio, ratio)
                this.$old[ref] = ratio
            }
        },

        resetScale(ref) {

            const sc = 1/this.$old[ref] 
            this.$Body.scale(this['$face_'+ ref], sc, sc)
        },

        getDistance(x1, y1, x2, y2) {

            const a = x1 - x2
            const b = y1 - y2
            return Math.sqrt( a*a + b*b )
        },

        initMatter() {

            // const cv = (this.$debug) ? this.$refs.matter : this.$refs.canvas
            const Render = Matter.Render
            const Runner = Matter.Runner
            const MouseConstraint = Matter.MouseConstraint
            const Mouse = Matter.Mouse
            const render = Render.create(
            {
                canvas: this.$refs.canvas,
                engine: this.$engine,
                options: {
                        width: this.$width,
                        height: this.$height,
                        showVelocity: true
                }
            })

            Render.run(render)

            const runner = Runner.create()
            Runner.run(runner, this.$engine)

            const mouse = Mouse.create(render.canvas)
            const mouseConstraint = MouseConstraint.create(this.$engine,
            {
                mouse: mouse,
                constraint: {
                    stiffness: 0.2,
                    render: {
                        visible: false
                    }
                }
            })

            this.$World.add(this.$world, mouseConstraint)
            render.mouse = mouse
            Render.lookAt(render, {
                    min: { x: 0, y: 0 },
                    max: { x: this.$width, y: this.$height }
            })
        },
        
    }
}
</script>














